import * as React from "react";
import { computed, observable, action, IObservableArray } from "mobx"
import { observer, inject } from "mobx-react";
import { DocumentStoreImpl } from "../Stores/DocumentStore";
import * as DocumentManagement from "../DocumentManagement";
import * as MetaManagement from "../MetaManagement";
import { DialogStore } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";

interface IDocumentMetaSelection {
	documentStore?: DocumentStoreImpl;
}

@observer
export class DocumentMetaSelection extends React.Component<IDocumentMetaSelection, {}> {

	render() {
		return <div className="wizardbox-content no--toolbar">
			<div className="wizardbox-module">
				<DocumentMetaSelectionList />
			</div>
		</div>;
	}
}

@inject('documentStore')
@observer
class DocumentMetaSelectionList extends React.Component<IDocumentMetaSelection, {}> {

	store: DocumentStoreImpl;
	allMetas: IObservableArray<MetaManagement.MetaInfo> = observable.array<MetaManagement.MetaInfo>([]);

	componentWillMount() {
		this.store = this.props.documentStore;
	}


	componentDidMount() {
		this.initDocumentMetaSelectionList();
	}

	@action
	private initDocumentMetaSelectionList() {
		this.store.metaDataWizardStore.isWizardBoxBusy = true;
		MetaManagement.queryMetasAsync("").then((allMetas) => {
			let notSetMetas = allMetas.filter((metaData) => {
				return !metaData.isGlobal && !this.store.model.metas.some((currentMeta) => {
					return currentMeta.metaGuid === metaData.guid;
				});
			});
			this.allMetas.replace(notSetMetas);
			this.store.metaDataWizardStore.isWizardBoxBusy = false;
		}).catch(error => {
			this.store.metaDataWizardStore.isWizardBoxBusy = false;
			DialogStore.showError(Strings.general.errorDialogTitle, error);
		});
	}


	render() {
		return <div className="list-simple">
			<ul>
				{
					this.allMetas.map(item => {
						return <DocumentMetaSelectionListItem key={item.guid} item={item} />
					})
				}
			</ul>
		</div>;
	}
}

interface IDocumentMetaSelectionListItemProps extends IDocumentMetaSelection {
	item: MetaManagement.MetaInfo;
}


@inject('documentStore')
@observer
class DocumentMetaSelectionListItem extends React.Component<IDocumentMetaSelectionListItemProps, {}> {

	store: DocumentStoreImpl;

	componentWillMount() {
		this.store = this.props.documentStore;
	}


	@action handleClickItem = () => {
		if (!this.store.addedDocumentMetas.remove(this.props.item.guid)) {
			this.store.addedDocumentMetas.push(this.props.item.guid);
		}
	}

	@computed get itemClass() {
		let isSelected = this.store.addedDocumentMetas.some((metaGuid) => { return this.props.item.guid === metaGuid; });
		return isSelected ? "is--selection-selected" : "";
	}


	render() {
		return <li className={this.itemClass} onClick={this.handleClickItem}>
			<a>
				<span>
					{this.props.item.caption}
				</span>
			</a>
		</li>
	}
}
